import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
//api
import { deleteEditorial } from 'api/products';
import { getAllEditorials } from 'api/pathForHook/products';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import Button from 'components/backoffice/buttonCustom';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import Title from 'components/backoffice/texts/title';
import SearchTable from 'components/backoffice/table/SearchTable';
import { usePermissions } from 'components/backoffice/PermissionsContext';

const Editorials = () => {
  const userPermissions = usePermissions();
  const navigate = useNavigate();
  const { t } = useTranslation(['backoffice']);
  const [listEditorials, setListEditorials] = useState([]);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [page, setPage] = useState(1);
  const [inputValue, setInputValue] = useState('');
  const [idItem, setIdItem] = useState();
  const [responseInfo, setResponseInfo] = useState({})
  const { setTitle } = useOutletContext()

  const colsEditorials = [
    'ID',
    t('backofficeEditorials.tableFiscalName'),
    t('actions')
  ];

  const { fetchData, stateData, loading } = useHandleSearch();

  const getListEditorials = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        search: inputValue,
        fields: 'id,nombre_fiscal'
      }
      await fetchData(getAllEditorials(), payload);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTitle(t('editoriales'))
    return () => {
      setTitle('');
    };
  }, [setTitle]);

  useEffect(() => {
    const { results, errors, noResults, totalPages } = stateData;
    if (results !== null) {
      setListEditorials(results);
      setResponseInfo({ errors, noResults, totalPages })
    } else {
      setListEditorials(null);
      setResponseInfo({ errors })
    }
  }, [stateData])

  useEffect(() => {
    if (page > 1 && inputValue !== '') {
      setPage(1);
    }
  }, [inputValue])

  useEffect(() => {
    getListEditorials();
  }, [page, inputValue]);

  const handleDelete = useCallback(async () => {
    const { status } = await deleteEditorial(idItem);
    if (status === 204) {
      toast.success(t('eliminadocorrectamente'));
      getListEditorials();
      setInputValue('');
    }
    setShowModalDelete(false);
  }, [showModalDelete]);

  const handleClear = () => {
    setInputValue('');
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }));
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, count: responseInfo?.count }));
  };

  const handleShowModalDelete = (item, id, setOpenModal) => {
    if (item.id === id) {
      setOpenModal(true);
      setIdItem(id);
    }
  };

  const handleEdit = (id) => navigate(`/intranet/editorials/edit/${id}`);
  const handleCreate = () => navigate(`/intranet/editorials/create`);

  return (
    <div>
      <Title text={t('backofficeEditorials.editorials')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col md={5} xs={12} className="d-flex text-start">
          <SearchTable
            value={inputValue}
            handleSearch={setInputValue}
            handleClear={handleClear}
            handleKeyDown={true}
            placeholder={t('searchbyfiscalname')}
          />
        </Col>
        <Col md={7} xs={12} className="text-end mt-3 mt-md-0">
          {userPermissions.includes('editorial.__add') && (
            <Button color="primary" onClick={handleCreate}>
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsEditorials}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {listEditorials &&
            listEditorials.map((listEditorial, index) => {
              return (
                <tr key={listEditorial.id}>
                  <td className="text-light">{`#${listEditorial.id}`}</td>
                  <td className="text-light ">{listEditorial.nombre_fiscal}</td>
                  <td className="text-light item-dropdown text-end">

                    <DropdownIcons idItem={index}
                      handleEdit={
                        userPermissions.includes('editorial.__modify')
                        && (() => handleEdit(listEditorial.id))
                      }
                      handleDelete={
                        userPermissions.includes('editorial.__delete')
                        && (() => handleShowModalDelete(listEditorial, listEditorial.id, setShowModalDelete))
                      }
                    />
                  </td>
                </tr>
              );
            })}
        </CustomTable>
      </div>
      <DeleteModalCustom
        openModal={showModalDelete}
        setOpenModal={setShowModalDelete}
        handleDelete={handleDelete}
        deleteTitle={t('deleteeditorial')}
        beforeTitle={t('editoriales')}
      />
    </div>
  );
};

export default Editorials;
